import React from "react"
import { banner } from "./warning.module.css"

const Warning = () => {
  return (
    <div className={banner}>
      <div className="wrapper">
        <p>
          <small>
            🚨 Atenção! A Facio nunca solicita depósito antecipado para a liberação do crédito
          </small>
        </p>
      </div>
    </div>
  )
}

export default Warning
